






































import {Vue, Component} from 'vue-property-decorator'

@Component
export default class ClaimGasUnexpectedErrorStep extends Vue {}
